import { useMemo } from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { leadTimeUnitList } from '@/module/Travel/Settings/model/TravelSettingsTypes';

import { EnumSelectControl, EnumSelectControlProps } from '@/core/components';

export type LeadTimeUnitSelectControlProps<T extends FieldValues> = Omit<EnumSelectControlProps<T>, 'options'>;

export function LeadTimeUnitSelectControl<T extends FieldValues>(props: LeadTimeUnitSelectControlProps<T>) {
  const { t } = useTranslation();
  const options = useMemo(
    () => leadTimeUnitList.map(value => ({ value, label: t(`travel.leadTimeUnitEnum.${value}`) })),
    [t],
  );

  return (
    <EnumSelectControl
      {...props}
      options={options}
    />
  );
}
